import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const InspectorModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;
  const newData = React.isValidElement(data?.value) ? { ...data, value: data.value.props?.value?.file_name } : data;

  return (
    <Styled.ModalOverlay onClick={onClose}>
      <Styled.ModalContent onClick={(e) => e.stopPropagation()}>
        <Styled.ModalHeader>
          <Styled.ModalTitle>Complete question's JSON Data</Styled.ModalTitle>
          <Styled.ModalCloseButton onClick={onClose}>X</Styled.ModalCloseButton>
        </Styled.ModalHeader>
        <Styled.ModalBody>
          <Styled.JsonDisplay>{JSON.stringify(newData, null, 2)}</Styled.JsonDisplay>
        </Styled.ModalBody>
      </Styled.ModalContent>
    </Styled.ModalOverlay>
  );
};

InspectorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object,
};

InspectorModal.defaultProps = {
  data: {},
};

export default InspectorModal;
